module.exports = __webpack_public_path__ + "static/media/empty.253d187b.svg";